const translations = {
    en: {
        restauranttitle: "Restaurant",
        gastronomytitle: "About us",
        cardtitle: "Our menus",
        cardtitle2:"Menu",
        winesmonth:"Month wines",
        vermouthtitle:"Drinks",
        contacttitle: "Contact and reservation",
        gastronomy: "About Us",
        card: "Our Menus",
        reservationbutton: "Booking",
        eslogan:"Enjoy Sharing",
        errorback:" Turn back to index",
        backicon:'Back arrow',
        errorsubtitle:"Page not found",
        contacttitle2: "Contact",
        legaltitle: "LEGAL",
        legalwarning: "Legal Warning",
        privacypolicy: "Privacy Policy",
        cookiespolicy:"Cookies Policy",
        instagramalt:"Instagram logo",
        copyright:"© Faro Restaurant",
        textaboutus1: 'Can you imagine a place where the tapas contain stories and each visit becomes a special memory? At FARO, our vermuteria in Castelldefels, we live to make you feel at home',
        textaboutus2: 'We are two brothers, passionate about what we do. In the kitchen, we transform fresh and seasonal ingredients into homemade Mediterranean tapas that you will want to share: from a delicious croquettes of pork leg to a Russian salad full of flavor. Meanwhile, in the dining room, we make sure you enjoy every moment with recommendations of perfect wines and vermouths and a close attention.',
        textaboutus3: 'Our space is small, yes, but full of warmth and good atmosphere. At FARO we don\'t just serve tapas; we create moments for you to laugh and as our slogan says: enjoy sharing',
        textaboutus4: 'Would you like to visit us? We are here, ready to welcome you with open arms!',
        logoalt:'logo Faro Castelldefels restaurant',
        ubiicon:"ubication icon",
        telicon:"telefone icon",
        mailicon:"mail icon",
        cartamenualt:"Menu of the Faro restaurant in Castelldefels",
        cartawinealt:"Wines of the Faro restaurant in Castelldefels",
        cartavermutalt:"Vermouths of the Faro restaurant in Castelldefels",
        chevronalt:"Down arrow chevron",
        tapasalt:"Tapas image from FARO Castelldefels",
        menucardalt:"Menú Icon of FARO Castelldefels",
        drinksiconalt:"Drinks icon of FARO Castelldefels",
        tapasbackgroundalt:"Tapas background image",
        facurodriimagealt:"FARO Castelldefels owners image",
        scheduletitle:"⏰ Schedule",
        schedule1:"Wednesday - Saturday 12h-15:30h 19:00h-23h",
        schedule2:"Sunday 12h-16h",
        designed:"Designed by: JuanmiClavero",
        developed:"Developed by: Pere Martínez Ibar",
        vermouth1:"Lacuesta Red",
        vermouth2:"Cala Morisca",
        vermouth3:"Lustau Red",
        vermouth4:"Lustau Rosé",
        vermouth5:"Lustau White",
        vermouth6:"Miró Red",
        vermouth7:"Miró White",
        vermouth8:"Rivera",
        cookiespopup1:"We use our own and third-party cookies to improve your experience. You can accept or reject cookies.",
        cookiespopup2:"More information",
        acceptcookies:"Accept",
        rejectcookies:"Reject",
        cookies1:"Cookie Policy",
        cookies2:"On this website we use our own and third-party cookies to improve the user experience, analyze traffic, and personalize content.",
        cookies3:"What are cookies?",
        cookies4:"Cookies are small text files that are stored on your device when you visit a website. They are used to recognize the user, remember their preferences, and improve the site’s performance.",
        cookies5:"Types of cookies used",
        cookies6:"Technical cookies:",
        cookies7:" necessary for the basic functioning of the site.",
        cookies8:"Analytics cookies:",
        cookies9:" allow the analysis of user behavior on the website.",
        cookies10:"Personalization cookies:",
        cookies11:" remember user preferences.",
        cookies12:"Cookie management",
        cookies13:"You can accept, reject, or configure the use of cookies from the cookie banner or through your browser settings.",
        cookies14:"How to disable cookies",
        cookies15:"You can allow, block, or delete cookies installed on your device through the configuration options of the browser you use.",
        cookies16:"Updates",
        cookies17:"This cookie policy may be updated due to legal requirements or changes to the website.",

      },
      es: {
        restauranttitle: "Restaurante",
        gastronomytitle: "Sobre nosotros",
        cardtitle: "Nuestras cartas",
        cardtitle2:"Carta de comida",
        winesmonth:"Vinos del mes",
        vermouthtitle:"Carta de bebidas",
        contacttitle: "Contacto y reserva",
        gastronomy: "Sobre Nosotros",
        card: "Nuestras Cartas",
        reservationbutton: "Reserva",
        eslogan:"Disfrutar Compartiendo",
        errorback:" Volver al inicio",
        backicon:'Flecha de ir para atrás',
        errorsubtitle:"Página no encontrada",
        contacttitle2: "Contacto",
        legaltitle: "LEGAL",
        legalwarning: "Aviso Legal",
        privacypolicy: "Política de Privacidad",
        cookiespolicy:"Política de Cookies",
        instagramalt:"Logo de Instagram",
        copyright:"© Restaurante Faro",
        textaboutus1:"¿Te imaginas un lugar donde las tapas cuentan historias y cada visita se convierte en un recuerdo especial? En FARO, nuestra vermuteria en Castelldefels, vivimos para hacerte sentir como en casa.",
        textaboutus2:"Somos dos hermanos, apasionados por lo que hacemos. En la cocina, transformamos ingredientes frescos y de temporada en tapas mediterráneas caseras que querrás compartir: desde unas croquetas de jamón que enamoran hasta una ensaladilla rusa llena de sabor. Mientras tanto, en sala, nos aseguramos de que disfrutes cada momento con recomendaciones de vinos y vermuts perfectos y una atención cercana.",
        textaboutus3:"Nuestro espacio es pequeño, sí, pero lleno de calidez y buen ambiente. En FARO no solo servimos tapas; creamos momentos para que rías y como dice nuestro eslogan: disfrutes compartiendo.",
        textaboutus4:"¿Te animas a visitarnos? ¡Estamos aquí, listos para darte la bienvenida con los brazos abiertos!",
        logoalt:'logo Faro Castelldefels restaurante',
        ubiicon:"icono de ubicación",
        telicon:"icono de teléfono",
        mailicon:"icono de correo electrónico",
        cartamenualt:"Carta del restaurante el Faro Castelldefels",
        cartawinealt:"Vinos del restaurante el Faro Castelldefels",
        cartavermutalt:"Vermuts del restaurante el Faro Castelldefels",
        chevronalt:"Flecha para abajo de menú de idiomas",
        tapasalt:"Imagen de tapas del FARO Castelldefels",
        menucardalt:"Icono de la carta del FARO Castelldefels",
        drinksiconalt:"Icono de bebidas del FARO Castelldefels",
        tapasbackgroundalt:"Imagen de fondo de Tapas",
        facurodriimagealt:"Imagen de los dueños del FARO Castelldefels",
        scheduletitle:"⏰ Horario",
        schedule1:"Miércoles - Sábado 12h-15:30h 19:00h-23h",
        schedule2:"Domingo 12h-16h",
        designed:"Diseñado por: JuanmiClavero",
        developed:"Desarrollado por: Pere Martínez Ibar",
        vermouth1:"Lacuesta Rojo",
        vermouth2:"Cala Morisca",
        vermouth3:"Lustau Rojo",
        vermouth4:"Lustau Rosé",
        vermouth5:"Lustau Blanco",
        vermouth6:"Miró Rojo",
        vermouth7:"Miró Blanco",
        vermouth8:"Rivera",
        acceptcookies: "Aceptar",
        rejectcookies: "Rechazar",
        cookiespopup1: "Utilizamos cookies propias y de terceros para mejorar tu experiencia. Puedes aceptar o rechazar las cookies.",
        cookiespopup2: "Más información",
        cookies1:"Política de Cookies",
        cookies2:"En este sitio web utilizamos cookies propias y de terceros para mejorar la experiencia del usuario, analizar el tráfico y personalizar el contenido.",
        cookies3:"¿Qué son las cookies?",
        cookies4:"Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Sirven para reconocer al usuario, recordar sus preferencias y mejorar el funcionamiento del sitio.",
        cookies5:"Tipos de cookies utilizadas",
        cookies6:"Cookies técnicas:",
        cookies7:" necesarias para el funcionamiento básico del sitio.",
        cookies8:"Cookies de análisis:",
        cookies9:" permiten analizar el comportamiento de los usuarios en el sitio web.",
        cookies10:"Cookies de personalización:",
        cookies11:" recuerdan preferencias del usuario.",
        cookies12:"Gestión de cookies",
        cookies13:"Puede aceptar, rechazar o configurar el uso de cookies desde el banner de cookies o a través de la configuración de su navegador.",
        cookies14:"Cómo desactivar las cookies",
        cookies15:"Puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador que utilice.",
        cookies16:"Actualizaciones",
        cookies17:"Esta política de cookies puede actualizarse en función de exigencias legales o cambios en el sitio web.",
      },
        ca: {
        restauranttitle: "Restaurant",
        gastronomytitle: "Sobre nosaltres",
        cardtitle: "Les nostres cartes",
        cardtitle2:"Carta de menjar",
        winesmonth:"Vins del mes",
        vermouthtitle:"Carta de begudes",
        contacttitle: "Contacte i reserva",
        gastronomy: "Sobre Nosaltres",
        card: "Les Nostres Cartes",
        reservationbutton: "Reserva",
        eslogan:"Gaudir Compartint",
        errorback:" Tornar al inici",
        backicon:'Fletxa d`anar enrere',
        errorsubtitle:"Pàgina no trobada",
        contacttitle2: "Contacte",
        legaltitle: "LEGAL",
        legalwarning: "Avís Legal",
        privacypolicy: "Política de Privadesa",
        cookiespolicy:"Política de Cookies",
        instagramalt:"Logotip d`Instagram",
        copyright:"© Restaurant Faro",
        textaboutus1:"T'imagines un lloc on les tapes conten històries i cada visita es converteix en un record especial? En FARO, nostra vermuteria a Castelldefels, vivim per a fer-te sentir com a casa.",
        textaboutus2:"Som dos germans, apassionats pel que fem. En la cuina, transformem ingredients frescos i de temporada en tapes mediterrànies casolanes que voldràs compartir: des d'unes croquetes de pernil que enamoren fins a una ensalada russa plena de sabor. Mentrestant, en sala, ens assegurem que gaudis cada moment amb recomanacions de vins i vermuts perfectes i una atenció pròxima.",
        textaboutus3:"El nostre espai és petit, sí, però ple de calidesa i bon ambient. En FARO no sols servim tapes; creem moments perquè ries i com diu el nostre eslògan: gaudis compartint.",
        textaboutus4:"T'animes a visitar-nos? Som aquí, llestos per a donar-te la benvinguda amb els braços oberts!",
        logoalt:'logotip Faro restaurant Castelldefels',  
        ubiicon:"icona d'ubicació",
        telicon:"icona de telèfon",
        mailicon:"icona de correu electrònic",
        cartamenualt:"Carta del restaurant el Faro Castelldefels",
        cartawinealt:"Vins del restaurant el Faro Castelldefels",
        cartavermutalt:"Vermuts del restaurant el Faro Castelldefels",
        chevronalt:"Fletxa cap abaix del menú d'idiomes",
        tapasalt:"Imatge de tapes del FARO Castelldefels",
        menucardalt:"Icona de la carta del FARO Castelldefels",
        drinksiconalt:"Icona de begudes del FARO Castelldefels",
        tapasbackgroundalt:"Imatge de fons de tapes",
        facurodriimagealt:"Imatge dels amos del FARO Castelldefels",
        scheduletitle:"⏰ Horari",
        schedule1:"Dimecres - Dissabte 12h-15:30h 19:00h-23h",
        schedule2:"Diumenge 12h-16h",
        designed:"Dissenyat per: JuanmiClavero",
        developed:"Desenvolupat per: Pere Martínez Ibar",
        vermouth1:"Lacuesta Negre",
        vermouth2:"Cala Morisca",
        vermouth3:"Lustau Negre",
        vermouth4:"Lustau Rosé",
        vermouth5:"Lustau Blanc",
        vermouth6:"Miró Negre",
        vermouth7:"Miró Blanc",
        vermouth8:"Rivera",
        cookiespopup1:"Utilitzem galetes pròpies i de tercers per millorar la teva experiència. Pots acceptar o rebutjar les galetes.",
        cookiespopup2:"Més informació",
        acceptcookies:"Acceptar",
        rejectcookies:"Rebutjar",
        cookies1:"Política de galetes",
        cookies2:"En aquest lloc web utilitzem galetes pròpies i de tercers per millorar l’experiència de l’usuari, analitzar el trànsit i personalitzar el contingut.",
        cookies3:"Què són les galetes?",
        cookies4:"Les galetes són petits fitxers de text que s’emmagatzemen al seu dispositiu quan visita un lloc web. Serveixen per reconèixer l’usuari, recordar les seves preferències i millorar el funcionament del lloc.",
        cookies5:"Tipus de galetes utilitzades",
        cookies6:"Galetes tècniques:",
        cookies7:" necessàries per al funcionament bàsic del lloc.",
        cookies8:"Galetes d’anàlisi:",
        cookies9:" permeten analitzar el comportament dels usuaris al lloc web.",
        cookies10:"Galetes de personalització:",
        cookies11:" recorden les preferències de l’usuari.",
        cookies12:"Gestió de galetes",
        cookies13:"Pot acceptar, rebutjar o configurar l’ús de galetes des del bàner de galetes o a través de la configuració del seu navegador.",
        cookies14:"Com desactivar les galetes",
        cookies15:"Pot permetre, bloquejar o eliminar les galetes instal·lades al seu equip mitjançant la configuració de les opcions del navegador que utilitzi.",
        cookies16:"Actualitzacions",
        cookies17:"Aquesta política de galetes pot actualitzar-se en funció d’exigències legals o canvis al lloc web.",
      }
};

export default translations